import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useField, useFormikContext } from "formik";
import { Text } from "../../text";
import { styled } from "../../theme";
import { useBlockComponentContext } from "../BlockComponentContext";
export const Caption = ({ fieldName, translationKey }) => {
    const [, meta] = useField(fieldName);
    const hasError = meta.touched && meta.error;
    const { Translated, Markdown } = useBlockComponentContext();
    const { values } = useFormikContext();
    const markdownRenderer = useCallback(({ translation }) => (_jsx(Markdown, { values: values, source: translation })), [values]);
    return (_jsx(CaptionText, { fontSize: "1.25em", color: hasError ? "deepOrange100" : undefined, children: _jsx(Translated, { translationKey: translationKey, render: markdownRenderer }) }));
};
const CaptionText = styled(Text) `
  display: block;
  padding: 30px 10px;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 10px;
`;
